import React, { FunctionComponent } from 'react';

import dompurify from 'dompurify';

import './ItvPromoCardTall.scss';

import { CardCTASection } from '../../../Layout/Promotions/PromotionCard/CardCTASection';
import { Paragraph } from '../../../shared/Paragraph';
import { Heading } from '../../../shared/Heading';
import { PromotionCardProps } from '../types';

export const ItvPromoCardTall: FunctionComponent<PromotionCardProps> = ({ promo, goToPromoPage }): JSX.Element => {
  const sanitizer = dompurify.sanitize;

  const { title, description, tallImg, startDate } = promo;

  // Check if promo is not yet available (startDate is in the future)
  const isNotYetAvailable = startDate ? new Date(startDate) > new Date() : false;

  return (
    <>
      <div
        className={`itv-promo-card-tall ${isNotYetAvailable ? 'itv-promo-card-tall--shadowed' : ''}`}
        style={{
          backgroundImage: `url(${tallImg})`,
        }}
        onClick={goToPromoPage}
      >
        <div className="itv-promo-card-tall__container">
          <Heading className="itv-promo-card-tall__title" noMargin level={4}>
            {title}
          </Heading>

          <div className="itv-promo-card-tall__bottom">
            <CardCTASection onViewDetailsClick={goToPromoPage} promo={promo} showPrimary={false} />

            {description && (
              <Paragraph className="itv-promo-card-tall__description" noMargin>
                <span dangerouslySetInnerHTML={{ __html: sanitizer(description) }} />
              </Paragraph>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
